import type { FC } from 'react';
import React from 'react';
import Countdown from 'antd/lib/statistic/Countdown';
import { useLocation } from 'umi';

interface TimerProps {
  style?: React.CSSProperties;
  className?: string;
  deadline?: number;
  onFinish?: () => void
}

/** 事件处理器 */
const Timer: FC<TimerProps> = ({ className, deadline = 0, onFinish }) => {
  const { query } = useLocation() as unknown as Location & { query: Record<string, string> };
  return (
    <div className={className} style={{ display: 'flex' }}>
      <Countdown value={new Date(deadline).toString()} onFinish={onFinish} />
      {/* <Countdown value={new Date(Date.now() + 20000).toString()} onFinish={onFinish} /> */}
      <span style={{ marginLeft: 15, fontSize: 16, color: 'red' }}>(超时将自动提交)</span>
      <a style={{marginLeft: 10}} onClick={() => {
        window.Pandora.send('zijin_testee_click_video', {
          onlyid: query.exam_id,
          page: 'question'
      });
      }} href="https://cdn.233xyx.com/1638532218655_171.mp4" target="_blank">教学视频</a>
    </div>
  );
};

export default Timer;
